module.exports = __webpack_public_path__ + "media/images/smart_phone/item/rate_4-c83f259cc5a58e6d171e82f327ddeb65.png";